import { render } from "./OurExpertsSection.vue?vue&type=template&id=d34461ac&scoped=true"
import script from "./OurExpertsSection.vue?vue&type=script&lang=js"
export * from "./OurExpertsSection.vue?vue&type=script&lang=js"

import "./OurExpertsSection.vue?vue&type=style&index=0&id=d34461ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d34461ac"]])

export default __exports__